module.exports = __webpack_public_path__ + "img/VCT.0fe69dfb.svg";